import { type Book } from '@editor2/types/book';
import { pick } from './pick';

export const bookToEditorFormProperties = (book: Book) => {
	const properties = pick(book, [
		'family_id',
		'name',
		'edition',
		'editorial_notes',
		'lecture_slide_decks_available'
	]);

	return properties;
};
